import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Carousel from './components/Carousel';
import Inicio from './components/Inicio';
import Sucursales from './components/Sucursales';
import Footer from './components/Footer';
import Modal from './components/Modal';
import Contacto from './components/Contacto';
import Reclutamiento from './components/Reclutamiento';
import Home from './components/Home';

function App() {
  const [openModalId, setOpenModalId] = useState(null);

  const handleOpenModal = (id) => {
    setOpenModalId(id);
  };

  const handleCloseModal = () => {
    setOpenModalId(null);
  };

 
  return (
  <Router basename={process.env.PUBLIC_URL}>
    <ScrollToTop />

    <div className="App">
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/sucursales" element={<Sucursales />} />
        <Route path="/reclutamiento" element={<Reclutamiento />} />
      </Routes>

      <Modal
        id="modalHome"
        title="Ferretería El Constructor"
        imgSrc="./images/home.jpg"
        isOpen={openModalId === "modalInicio"}
        onClose={handleCloseModal}
      />

      <Modal
        id="modalMision"
        title="Ferretería El Constructor"
        imgSrc="./images/vision.jpg"
        isOpen={openModalId === "modalInicio"}
        onClose={handleCloseModal}
      />

      <Modal
        id="modalMatriz"
        title="Local Matriz Cayambe"
        imgSrc="./images/local-matriz.png"
        isOpen={openModalId === "modalInicio"}
        onClose={handleCloseModal}
      />

      <Modal
        id="modalSigsal"
        title="Local Sigsal Cayambe"
        imgSrc="./images/local-sigsal.jpg"
        isOpen={openModalId === "modalInicio"}
        onClose={handleCloseModal}
      />

      <Modal
        id="modalTabacundo"
        title="Local Tabacundo"
        imgSrc="./images/local-tabacundo.png"
        isOpen={openModalId === "modalInicio"}
        onClose={handleCloseModal}
      />

      <Footer />
    </div>
  </Router>
);
}

export default App;